import axiosInstance from "./axiosInstance";


export const fetchDistributors = async (data) => {
  const res = await axiosInstance.post(`/Dash/get_master`,data);
  const raw = res.data?.data[0]?.get_dash_master_data?.master_data
  return raw || []
};


export const addDistributor = async (data) => {
  const res = await axiosInstance.post(`/master/add_distributor`,data);
  const raw = res.data?.data[0]?.insert_update_distributor_master;
  return raw || []
};


// In distributorApi.js
export const fetchStockVerification = async ({ state }) => {
  // Use GET with query parameter (as shown in the curl)
  const res = await axiosInstance.get(`/Stock/latest_by_state`, {
    params: { state }
  });
  // Extract the nested array from the response
  // Path: res.data.data[0].fn_get_latest_stock_by_state.data
  const stockData = res.data?.data?.[0]?.fn_get_latest_stock_by_state?.data;
  return stockData || [];
};